import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, NavigationEnd, Router, RouterStateSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { AuthService } from '@gelato-api-ui/core/auth/auth.service';
import * as actions from '../../ngrx/price-plan-selection-list.actions';

@Injectable({
  providedIn: 'root',
})
export class PricePlanSelectionListGuard implements CanActivate {
  previousUrl: string = null;

  constructor(private store: Store<AppState>, private authService: AuthService, private router: Router) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.previousUrl = event.url;
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const stateUrl = (state.url || '').split(';')[0];
    const previousUrl = (this.previousUrl || '').split(';')[0];

    if (stateUrl !== previousUrl) {
      this.authService.isGelatoUser().subscribe(hasPermission => {
        if (hasPermission) {
          this.store.dispatch(new actions.Load());
        }
      });
    }

    return true;
  }
}
